import { render, staticRenderFns } from "./select_product_transfer.vue?vue&type=template&id=4460f7a9&scoped=true&"
import script from "./select_product_transfer.vue?vue&type=script&lang=js&"
export * from "./select_product_transfer.vue?vue&type=script&lang=js&"
import style0 from "./select_product_transfer.vue?vue&type=style&index=0&id=4460f7a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4460f7a9",
  null
  
)

export default component.exports